import { withTag, type AdPlatform } from "./types";

// Installed by `loadRedditPixel()` in marketing.js, which defines rdt as a queue
// (`rdt.callQueue`) before pixel.js loads, so early calls are kept.
type Rdt = (
  action: "track",
  event: string,
  payload?: { customEventName: string }
) => void;

declare global {
  interface Window {
    rdt?: Rdt;
  }
}

// The only event names Reddit recognises. Anything else must be sent as
// `Custom`, with the name in `customEventName`.
const STANDARD_EVENTS = new Set([
  "PageVisit",
  "ViewContent",
  "Search",
  "AddToCart",
  "AddToWishlist",
  "Purchase",
  "Lead",
  "SignUp"
]);

/**
 * Reddit Pixel. Conversion tokens are event names rather than opaque ids, so
 * the mapping to Reddit's event model is absorbed here.
 */
export const reddit: AdPlatform = {
  name: "Reddit",
  key: "reddit",
  accountIdKey: "ID_REDDIT_PIXEL",
  send: withTag(
    () => window.rdt,
    (rdt, event) =>
      STANDARD_EVENTS.has(event)
        ? rdt("track", event)
        : rdt("track", "Custom", { customEventName: event })
  )
};
